import $ from "jquery";
import { Klass } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

function addHeader(vuw) {
	if( !( vuw instanceof Klass("Vuw") ) ) {
		throw new TypeError("arguments[0] must be Vuw instance.");
	}
	
	vuw.add("header", {
		selector() {
			return this.container.$self.children("thead");
		},
		
		onReady($self) {
			$self.on("click", ".btn-sort", e => {
				e.preventDefault();
				
				const $btn = $(e.currentTarget);
				const areaId = $btn.parent(".area-sort").attr("id");
				const sortId = areaId.split("_").slice(1).join("_");
				const sortDirection = e.currentTarget.className.split(" ")[1];
				
				$btn.hasClass("sorted") || vuwer.setState("sort", `${sortId},${sortDirection}`);
			});
		}
	});
}

export default addHeader;
